import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {useEffect, useRef, useState} from 'react';
import {useDialog} from 'react-aria';
import {createPortal} from 'react-dom';

import {TOP_NAV_HEIGHT} from '../../util/constants';
import {useNightModeRevertFilter} from './useNightModeRevertFilter';
import {WBAgentHeader} from './WBAgentHeader';
import {WBAgentThread} from './WBAgentThread';

function useNavbarBottom() {
  const [navbarBottom, setNavbarBottom] = useState(TOP_NAV_HEIGHT);

  useEffect(() => {
    const update = () => {
      const navbar = document.querySelector('.search-nav');
      if (navbar) {
        setNavbarBottom(Math.max(0, navbar.getBoundingClientRect().bottom));
      }
    };

    update();
    document.addEventListener('scroll', update, {capture: true, passive: true});
    window.addEventListener('resize', update, {passive: true});
    return () => {
      document.removeEventListener('scroll', update, {capture: true});
      window.removeEventListener('resize', update);
    };
  }, []);

  return navbarBottom;
}

const SIDEBAR_WIDTH = 400;

export const WBAgentChatDrawer = () => {
  const ref = useRef<HTMLDivElement>(null);
  const {dialogProps} = useDialog({'aria-label': 'W&B Agent sidebar'}, ref);
  const navbarBottom = useNavbarBottom();
  const nightModeRevertFilter = useNightModeRevertFilter();

  return createPortal(
    <Tailwind>
      <div
        ref={ref}
        {...dialogProps}
        className="fixed top-0 right-0 bottom-0 z-[1000] flex flex-col min-h-0 overscroll-none"
        style={{width: SIDEBAR_WIDTH, paddingTop: navbarBottom}}>
        <div
          className="absolute inset-0 border-l border-moon-250 bg-white dark:bg-moon-850 dark:border-[#363C44] shadow-[0_12px_24px_0_rgba(13,15,18,0.16)] dark:shadow-[0_12px_24px_0_rgba(13,15,18,0.32)]"
          style={{filter: nightModeRevertFilter}}
        />
        <div className="relative flex flex-col flex-1 min-h-0">
          <WBAgentHeader />
          <WBAgentThread />
        </div>
      </div>
    </Tailwind>,
    document.body
  );
};
